import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const CustomCursor = () => {
  const ringRef = useRef(null);
  const dotRef = useRef(null);
  const [hover, setHover] = useState(false);
  const [mounted, setMounted] = useState(false);
  const target = useRef({ x: 0, y: 0 });
  const current = useRef({ x: 0, y: 0 });

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;

    const onMove = (e) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%,-50%)`;
      }
    };
    const onOver = (e) => {
      const el = e.target.closest("a, button, [data-magnetic], input, textarea, [role='button']");
      setHover(!!el);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);

    let raf;
    const loop = () => {
      current.current.x += (target.current.x - current.current.x) * 0.18;
      current.current.y += (target.current.y - current.current.y) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${current.current.x}px, ${current.current.y}px) translate(-50%,-50%)`;
      }
      raf = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, [mounted]);

  if (!mounted || typeof document === "undefined") return null;

  return createPortal(
    <>
      <div ref={ringRef} className={`dv-cursor ${hover ? "hover" : ""}`} data-testid="custom-cursor-ring" />
      <div ref={dotRef} className="dv-cursor-dot" />
    </>,
    document.body
  );
};

export default CustomCursor;
